import { render, staticRenderFns } from "./CameraPhoto.vue?vue&type=template&id=7d431555&lang=pug"
import script from "./CameraPhoto.vue?vue&type=script&lang=js"
export * from "./CameraPhoto.vue?vue&type=script&lang=js"
import style0 from "./CameraPhoto.vue?vue&type=style&index=0&id=7d431555&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports